export default __webpack_public_path__ + "static/media/weuro.f7523bfa.svg";